import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";

const Chapter21 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);

    return (
        <>
                 {/* Chapter 21 */}
                <section id="section21" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">
                        {language.chapter21Title}
                    </h2>


                    <ul className="drivers-handbook-list">
                        <li> {language.chapter21List11}</li>
                        <li>{language.chapter21List12}.</li>
                        <li>{language.chapter21List13}</li>
                        <li>{language.chapter21List14}</li>
                        <li>{language.chapter21List15}</li>
                        <li>{language.chapter21List16}</li>
                        <li>{language.chapter21List17}</li>
                        <li>{language.chapter21List18}</li>
                        <li>{language.chapter21List19}</li>
                        <li>{language.chapter21List20}</li>
                        <li>{language.chapter21List21}</li>
                        <li>{language.chapter21List22}</li>
                        <li>{language.chapter21List23}</li>
                        <li>{language.chapter21List24}</li>
                        <li>{language.chapter21List25}</li>
                    </ul>
                </section>

        </>
    )

}

export default Chapter21;
